import { create } from "zustand";

export type NotificationType = "success" | "error";

interface NotificationState {
  message: string | null;
  type: NotificationType;
  show: (message: string, type?: NotificationType) => void;
  hide: () => void;
}

export const useNotificationStore = create<NotificationState>((set) => ({
  message: null,
  type: "success",
  show: (message, type = "success") => set({ message, type }),
  hide: () => set({ message: null }),
}));
